module.exports = __webpack_public_path__ + "img/icon-speed-10.458b8bea.svg";